export default {
  bind(el, binding) {
    let timer = null
    let isFirstClick = true

    el.addEventListener('click', (event) => {
      event.stopPropagation()

      // 第一次点击立即执行
      if (isFirstClick) {
        binding.value()
        isFirstClick = false

        // 设置冷却时间，在指定时间内不再触发
        timer = setTimeout(() => {
          isFirstClick = true
          timer = null
        }, 1000)
        return
      }

      // 如果在冷却时间内，直接返回，不执行
      if (timer) {
        return
      }
    })
  },

  unbind(el) {
    // 清理事件监听器
    el.removeEventListener('click', el._debounceHandler)
  },
}
